import React from "react";
import { useNavigate } from "react-router-dom";

import RoadMap from "../../../assets/roadmap.webp";
import { exploreSurveyIntentPath } from "../../../configs/ExploreSurveyConfig";
import { pageConfigBySlug } from "../../../services/nav/NavigationService";
import {
  IDashboardDemandResponsePayload,
  IDashboardTileResult,
} from "../../../services/zeos-api/contracts/Dashboard";
import { DashboardMetricTile } from "../shared/DashboardMetricTile";

interface IProps {
  unlocked: boolean;
  setUnlocked: (unlocked: boolean) => void;
  tileResult?: IDashboardTileResult<IDashboardDemandResponsePayload>;
  loading?: boolean;
}

export const DemandResponse = (props: IProps) => {
  const navigate = useNavigate();
  const exploreSlug = pageConfigBySlug("explore")?.slug || "explore";
  // Framework-only placeholder (DB-F5): defaults to a defined not_connected state so the tile
  // always renders through the shared state framework rather than failing silently.
  const tileResult =
    props.tileResult ??
    ({
      status: "not_connected",
      message: "Demand response is not yet available for this property.",
      data: null,
    } as IDashboardTileResult<IDashboardDemandResponsePayload>);

  const handleExploreClick = () =>
    navigate(exploreSurveyIntentPath(exploreSlug, "demand-response"));

  return (
    <DashboardMetricTile
      tileKey="dr"
      title="Demand Response"
      image={RoadMap}
      navPath="dr"
      unlocked={props.unlocked}
      setUnlocked={props.setUnlocked}
      tileResult={tileResult}
      loading={props.loading}
      lockedCopy={{
        bodyHeading: "THE ROAD AHEAD",
        bodyContent:
          "Get realtime information on demand response programs and your progress. Sign up to be the first to try it.",
        onExploreClick: handleExploreClick,
        secondaryButtonTitle: "Notify Me",
        forceColor: true,
      }}
      metrics={[
        {
          label: "Curtailment",
          value: null,
          unit: "kW",
          tone: "positive",
        },
        {
          label: "Program Revenue",
          value: null,
          unit: "$",
          tone: "positive",
        },
      ]}
    />
  );
};
